/**
 * @generated SignedSource<<da7b7ecee8302df07141f697505fa392>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSimilarSoldItemsHeader_item$data = {
  readonly categoryL3: ReadonlyArray<{
    readonly name: string | null;
  } | null> | null;
  readonly pdpDetailsDisplay: ReadonlyArray<{
    readonly detailKey: string | null;
    readonly detailValues: ReadonlyArray<{
      readonly displayName: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "PdpSharedSimilarSoldItemsHeader_item";
};
export type PdpSharedSimilarSoldItemsHeader_item$key = {
  readonly " $data"?: PdpSharedSimilarSoldItemsHeader_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarSoldItemsHeader_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSimilarSoldItemsHeader_item",
  "selections": [
    {
      "alias": "categoryL3",
      "args": [
        {
          "kind": "Literal",
          "name": "level",
          "value": 3
        }
      ],
      "concreteType": "Category",
      "kind": "LinkedField",
      "name": "getCategoriesByLevel",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": "getCategoriesByLevel(level:3)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PdpDetail",
      "kind": "LinkedField",
      "name": "pdpDetailsDisplay",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "detailKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "detailValues",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "451e81e373398ac90ba6538af05126ac";

export default node;
